<template>
  <div>
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="单次考试分析" name="singleExam"></el-tab-pane>
        <el-tab-pane label="项目成绩趋势" name="subjectLine"></el-tab-pane>
        <el-tab-pane label="考站成绩分析" name="stationAnalysis"></el-tab-pane>
        <el-tab-pane label="考核点分析" name="standardAnalysis"></el-tab-pane>
      </el-tabs>
    </div>
    <div>
      <router-view></router-view>
    </div>
  </div>

</template>

<script>
    export default {
        data() {
            return {
                activeName: 'singleExam'
            };
        },
        methods: {
            handleClick(tab, event) {
                const name=tab.name
                this.$router.push({name:name})
            }
        }
    };
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/page/statisticsManage/subjectAnalysis.vue